export default __webpack_public_path__ + "static/media/173.4c08d963.jpg";